/**
 * Extracts the value of a specified query parameter from the current URL.
 * @param {string} paramName - The name of the query parameter to retrieve.
 * @returns {string} The value of the query parameter, or an empty string if not found.
 */
export default function getParamFromURL(paramName, defaultValue = null) {
  // Create a URL object based on the current window's location
  const url = new URL(window.location.href);

  // Extract the search parameters from the URL
  const searchParams = new URLSearchParams(url.search);

  // Attempt to get the value of the specified query parameter
  let paramValue = searchParams.get(paramName);

  // Return the parameter value, or the default value if not found
  return paramValue ? paramValue : defaultValue;
}
